import { useState } from "react";
import {
  Dialog, DialogContent, DialogHeader, DialogTitle, DialogFooter,
} from "./ui/dialog";

export default function MarkDoneDialog({ open, onOpenChange, onConfirm, title = "Mark done" }) {
  const [notes, setNotes] = useState("");
  const [link, setLink] = useState("");
  const [result, setResult] = useState("");
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="bg-[#12151E] border-[#2A3042] text-[#F8FAFC]" data-testid="mark-done-dialog">
        <DialogHeader>
          <DialogTitle className="font-display text-xl">{title}</DialogTitle>
        </DialogHeader>
        <div className="space-y-3">
          <div>
            <label className="text-xs text-[#94A3B8]">Notes (optional)</label>
            <textarea data-testid="markdone-notes" value={notes} onChange={(e) => setNotes(e.target.value)}
              className="w-full mt-1 px-3 py-2 rounded-lg bg-[#0A0C10] border border-[#2A3042] outline-none focus:border-[#D4AF37] text-sm" rows={2} />
          </div>
          <div>
            <label className="text-xs text-[#94A3B8]">Link to published content (optional)</label>
            <input data-testid="markdone-link" value={link} onChange={(e) => setLink(e.target.value)}
              className="w-full mt-1 px-3 py-2 rounded-lg bg-[#0A0C10] border border-[#2A3042] outline-none focus:border-[#D4AF37] text-sm" />
          </div>
          <div>
            <label className="text-xs text-[#94A3B8]">Result (optional, e.g. "3 inquiries")</label>
            <input data-testid="markdone-result" value={result} onChange={(e) => setResult(e.target.value)}
              className="w-full mt-1 px-3 py-2 rounded-lg bg-[#0A0C10] border border-[#2A3042] outline-none focus:border-[#D4AF37] text-sm" />
          </div>
        </div>
        <DialogFooter>
          <button onClick={() => onOpenChange(false)} className="px-4 py-2 rounded-lg border border-[#2A3042] text-[#94A3B8] text-sm">Cancel</button>
          <button data-testid="markdone-confirm" onClick={() => { onConfirm({ notes, link, result: result ? { note: result } : {} }); setNotes(""); setLink(""); setResult(""); }}
            className="gold-btn px-4 py-2 rounded-lg text-sm">Confirm done</button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
